{
  "title": "IA Utilizada por {{email}}",
  "button": "Mi Uso de AI",
  "model": "Modelo",
  "period": "Periodo",
  "periods-hourly": "Por Hora",
  "periods-weekly": "Semanal",
  "periods-monthly": "Mensual",
  "prompt-tokens": "Fichas de Entrada",
  "prompt-limit": "Límite (%)",
  "completion-tokens": "Fichas de Salida",
  "completion-limit": "Límite (%)",
  "total-tokens": "Fichas Totales",
  "total-limit": "Límite (%)",
  "requests": "Solicitudes",
  "request-limit": "Límite (%)",
  "estimated-monthly-cost": "Costo Mensual Estimado",
  "prompt-cost": "Costo de Entrada",
  "completion-cost": "Costo de Salida",
  "total-cost": "Costo Total",
  "no-usage": "No hay datos de uso disponibles",
  "request-failed": "No se pudo cargar el uso de IA",
  "close": "Cerrar"
}
